module.exports = __webpack_public_path__ + "static/eis_charlie-6858910da6e6de8f9a18e71c00f05317.png";